module.exports = __webpack_public_path__ + "static/media/fz_schdviewrobotconfirmed_en_US.05d42f82.png";